import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  margin-bottom: 15px;
`;

const Content = styled.p`
  line-height: 1.7em;
  font-size: 16px !important;
  /* font-weight: 350 !important; */
   
  margin-top: 5px;
  color: rgba(64, 64, 64, 1);

  h1, h2, h3, h4, h5, h6, b, strong{
    font-weight: bold !important;
    margin: 20px 0 15px;
  }

  h1 { font-size: 20px !important;   }
  h2 { font-size: 18px !important;   }
  h3 { font-size: 16px !important;   }
  h4 { font-size: 14px !important;   }
  h5 { font-size: 13px !important;   }
  h6 { font-size: 13px !important;   }
`;

const Description = ({ content }) => (
  <Container>
    <Content dangerouslySetInnerHTML={{ __html: content }} />
  </Container>
);

export default Description;
